import {makeStyles} from '@material-ui/core/styles';


const styleFooter= makeStyles({
  borderBox:{
    textAlign: 'center',
    // fontSize:'1.5em',
    fontFamily:['Black Ops One','cursive'],
    marginTop:20,
    paddingBottom:20,
  },
  footnote:{
    margin:0,
    padding:0,
  },
});

export default styleFooter;